export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--ok-v3.5053d226.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};